const fields = {
  name: {
    id: "name",
    isRequired: true,
    label: "First name and Last name",
    placeholder: "John Doe",
    type: "text",
    description: "Your full legal name for billing purposes",
  },
  nickname: {
    id: "nickname",
    isRequired: false,
    label: "Nickname",
    placeholder: "John",
    type: "text",
    description: "How should your assistant address you?",
  },
  photo_url: {
    id: "photo_url",
    label: "Profile picture",
    description: "Setting a profile picture helps your assistant get to know you better.",
  },
  company: {
    id: "company",
    isRequired: true,
    label: "Company name",
    placeholder: "Acme Co.",
    type: "text",
  },
  company_size: {
    id: "company_size",
    isRequired: true,
    label: "Company size",
    placeholder: "Choose",
    type: "select",
    choices: ["0-2", "3-9", "10-49", "50-99", "100-249", "250 or more"],
  },
  country: {
    id: "country_id",
    isRequired: true,
    label: "Country",
    placeholder: "Choose country",
  },
  region: {
    id: "region_id",
    isRequired: true,
    label: "State/Province",
    placeholder: "Choose state/province",
  },
  city: {
    id: "city_id",
    isRequired: true,
    label: "City",
    placeholder: "Choose city",
  },
  timezone: {
    id: "timezone",
    isRequired: true,
    label: "Timezone",
    placeholder: "Choose a timezone",
    type: "timezone",
    choiceKey: 1,
    choiceValue: 1,
    choiceHint: 0,
    choices: [
      [-12, "(GMT -12:00) Eniwetok, Kwajalein"],
      [-11, "(GMT -11:00) Midway Island, Samoa"],
      [-10, "(GMT -10:00) Hawaii"],
      [-9, "(GMT -9:00) Alaska"],
      [-8, "(GMT -8:00) Pacific Time (US & Canada)"],
      [-7, "(GMT -7:00) Mountain Time (US & Canada)"],
      [-6, "(GMT -6:00) Central Time (US & Canada), Mexico City"],
      [-5, "(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima"],
      [-4, "(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz"],
      [-3.5, "(GMT -3:30) Newfoundland"],
      [-3, "(GMT -3:00) Brazil, Buenos Aires, Georgetown"],
      [-2, "(GMT -2:00) Mid-Atlantic"],
      [-1, "(GMT -1:00 hour) Azores, Cape Verde Islands"],
      [0, "(GMT) Western Europe Time, London, Lisbon, Casablanca"],
      [1, "(GMT +1:00 hour) Brussels, Copenhagen, Madrid, Paris"],
      [2, "(GMT +2:00) Kaliningrad, South Africa"],
      [3, "(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg"],
      [3.5, "(GMT +3:30) Tehran"],
      [4, "(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi"],
      [4.5, "(GMT +4:30) Kabul"],
      [5, "(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent"],
      [5.5, "(GMT +5:30) Bombay, Calcutta, Madras, New Delhi"],
      [5.75, "(GMT +5:45) Kathmandu"],
      [6, "(GMT +6:00) Almaty, Dhaka, Colombo"],
      [7, "(GMT +7:00) Bangkok, Hanoi, Jakarta"],
      [8, "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong"],
      [9, "(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk"],
      [9.5, "(GMT +9:30) Adelaide, Darwin"],
      [10, "(GMT +10:00) Eastern Australia, Guam, Vladivostok"],
      [11, "(GMT +11:00) Magadan, Solomon Islands, New Caledonia"],
      [12, "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka"],
    ],
  },
  birthdate: {
    id: "birthdate",
    isRequired: false,
    label: "Birthdate",
    placeholder: "MM/DD/YYYY",
    type: "datetime",
    description: "Format: MM/DD/YYYY",
  },
  sex: {
    id: "sex",
    label: "Preferred pronoun",
    isInline: true,
    isRequired: false,
    type: "radio",
    description:
      "Setting your gender pronoun helps your assistant to use the most respectful language when addressing you.",
    choices: [
      [
        { _id: "She/her", name: "She/her" },
        { _id: "He/him", name: "He/him" },
        { _id: "They/them", name: "They/them" },
        { _id: "sex_others", name: "Other", conditional: { label: "Other preferred pronoun" } },
      ],
    ],
  },
  sex_others: {
    id: "sex_others",
    isRequired: true,
    label: "Other preferred pronoun",
    placeholder: "She/her",
    type: "text",
    replaceField: (data) => (data["sex"] === "sex_others" ? "sex" : null),
    isOmitted: true,
  },
  about_me: {
    id: "about_me",
    label: "About Me",
  },
  review: {
    id: "review",
    label: "Review your profile",
    description:
      "Please review your profile and click save at the bottom. This is what your assistant will see:",
  },
  role: {
    id: "role",
    label: "Role/Title",
    isRequired: true,
    type: "radio",
    choices: [
      [
        { _id: "founder / owner", name: "founder / owner" },
        { _id: "executive", name: "executive" },
        { _id: "role_others", name: "Other", conditional: { label: "Other role/title" } },
      ],
      [
        { _id: "CEO", name: "CEO" },
        { _id: "manager", name: "manager" },
      ],
      [
        { _id: "entrepreneur", name: "entrepreneur" },
        { _id: "professional", name: "professional" },
      ],
    ],
  },
  role_others: {
    id: "role_others",
    isRequired: true,
    label: "Other Role/Title",
    type: "text",
    replaceField: (data) => (data["role"] === "role_others" ? "role" : null),
    isOmitted: true,
  },
  need: {
    id: "need",
    label: "Assistant need",
    isRequired: false,
    type: "radio",
    choices: [
      [
        {
          _id: "Work with me closely to execute my ideas",
          name: "Work with me closely to execute my ideas",
        },
        {
          _id: "Take on a task that someone is currently doing",
          name: "Take on a task that someone is currently doing",
        },
        {
          _id: "Assist my team with anything they need",
          name: "Assist my team with anything they need",
        },
        { _id: "need_others", name: "Other", conditional: { label: "Other needs" } },
      ],
    ],
  },
  need_others: {
    id: "need_others",
    isRequired: true,
    label: "Other needs",
    type: "text",
    replaceField: (data) => (data["need"] === "need_others" ? "need" : null),
    isOmitted: true,
  },
  goal: {
    id: "goal",
    label: "Assistant goal",
    isRequired: false,
    type: "radio",
    choices: [
      [
        { _id: "Help me grow my business", name: "Help me grow my business" },
        { _id: "Help me perform better at work", name: "Help me perform better at work" },
        { _id: "Help my team accomplish their goals", name: "Help my team accomplish their goals" },
        { _id: "Turn my ideas into reality", name: "Turn my ideas into reality" },
        { _id: "goal_others", name: "Other", conditional: { label: "Other goal(s)" } },
      ],
    ],
  },
  goal_others: {
    id: "goal_others",
    isRequired: true,
    label: "Other goals",
    type: "text",
    replaceField: (data) => (data["goal"] === "goal_others" ? "goal" : null),
    isOmitted: true,
  },
  communication_visibility: {
    id: "communication_visibility",
    label: "Assistant should message me on",
    type: "checkbox",
    isRequired: false,
    choices: [
      [
        {
          _id: "Slack",
          name: "Slack",
          conditional: {
            label: "What's your Slack group URL?",
            placeholder: "https://yourcompany.slack.com",
          },
        },
        {
          _id: "Telegram",
          name: "Telegram",
          conditional: {
            label: "What's your Telegram number or username?",
            placeholder: "@myusername",
          },
        },
        {
          _id: "WhatsApp",
          name: "WhatsApp",
          conditional: {
            label: "What's your phone number for WhatsApp?",
            placeholder: "+15555555555",
          },
        },
        {
          _id: "Signal",
          name: "Signal",
          conditional: {
            label: "What's your phone number for Signal?",
            placeholder: "+1-123-456-7890",
          },
        },
        {
          _id: "Email",
          name: "Email",
          conditional: {
            label: "What's your email for communication?",
            placeholder: "me@mycompany.com",
          },
        },
        {
          _id: "communication_others",
          name: "Other(s)",
          conditional: {
            label: "Other app(s) to message me on",
            placeholder: "Other app's username/handle",
          },
          isOmitted: true,
        },
      ],
    ],
  },
  message_me: {
    id: "message_me",
    label: "Assistant should message me when",
    isRequired: false,
    type: "checkbox",
    choices: [
      [
        { _id: "login", name: "Assistant logs in" },
        { _id: "logout", name: "Assistant is about to log out" },
        { _id: "updates", name: "Assistant has important updates" },
        { _id: "questions", name: "Assistant has questions" },
        {
          _id: "message_others",
          name: "Other(s)",
          conditional: { label: "Other time to message me" },
          isOmitted: true,
        },
      ],
    ],
  },
  message_others: {
    id: "message_others",
    label: "Other time to message me",
    isRequired: true,
    placeholder: "Type something and press enter...",
    appendField: (data) => (data["message_me"].includes("Other(s)") ? "message_me" : ""),
    isOmitted: true,
  },
  tools: {
    id: "tools",
    label: "Software I am using at work",
    isRequired: false,
    type: "checkbox",
    choices: [
      [
        { _id: "google", name: "Google Suite" },
        { _id: "asana", name: "Asana" },
        { _id: "monday", name: "Monday" },
      ],
      [
        { _id: "microsoft", name: "Microsoft 365" },
        { _id: "trello", name: "Trello" },
        { _id: "notion", name: "Notion" },
      ],
      [
        { _id: "dropbox", name: "Dropbox" },
        { _id: "zoom", name: "Zoom" },
        { _id: "tools_others", name: "Other(s)", isOmitted: true },
      ],
    ],
  },
  tools_others: {
    id: "tools_others",
    label: "Other software I am using",
    placeholder: "Type something and press enter...",
    appendField: (data) => (data["tools"].includes("Other(s)") ? "tools" : ""),
    isOmitted: true,
  },
};

export default fields;

export const checkboxOptions = [
  "sex",
  "role",
  "need",
  "goal",
  "message_me",
  "tools",
  "communication_visibility",
].reduce((acc, cur) => {
  const allChoices = fields[cur].choices.flat();
  return {
    ...acc,
    [cur]: {
      default: allChoices.filter((choice) => choice.name !== "Other(s)" && choice.name !== "Other"),
      other: allChoices.filter((choice) => choice.name === "Other(s)" || choice.name === "Other"),
    },
  };
}, {});
